import React, { useCallback, useEffect, useRef } from 'react';
import css from './styles.module.scss';
import { Card } from '@material-ui/core';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useFeaturePath } from '~/utils/hooks/useFeaturePath';
import { FEATURE_ROUTER_PATH } from '~/features/creators-list';
import * as DashboardFeature from '~/features/dashboard';
import { CreatorListItem } from '~/models/creatorsList.dto';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { CREATOR_ACTION_ITEMS } from '~/features/creators-list';

interface CreatorCardProps {
    data: CreatorListItem;
}

export const CreatorCard1: React.FC<CreatorCardProps> = ({ data }) => {
    const route = useAppRoute();

    const getPath = useFeaturePath(FEATURE_ROUTER_PATH);

    const handleClick = useCallback(() => {
        route(getPath(`/${data.projectId}/dashboard/money`));
    }, [data.projectId, getPath, route]);

    const [expanded, setExpanded] = React.useState(false);

    return (
        <Card className={css.card1}>
            <CardMedia
                className={css.image}
                onClick={() => handleClick()}
                image={data.creatorImage ? process.env.REACT_APP_ASSET + data.creatorImage : '/fake-user-image.png'}
            />

            <CardActions className={css.morebutton} disableSpacing>
                <CardContent className={css.titleSection}>
                    <Typography className={css.projectName}>{data.projectName}</Typography>
                    <Typography className={css.creatorName}>{data.creatorName}</Typography>
                </CardContent>

                <IconButton aria-label="add to favorites" onClick={() => setExpanded(!expanded)}>
                    <MoreVertIcon />
                </IconButton>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent className={css.bottom}>
                    {Object.values(CREATOR_ACTION_ITEMS).map(props => (
                        <ButtonBox key={props.title} creatorId={data.projectId} {...props} />
                    ))}
                </CardContent>
            </Collapse>
        </Card>
    );
};

interface ButtonBox_Props {
    background: string;
    title: string;
    link: string;
    creatorId: number;
}

const ButtonBox: React.FC<ButtonBox_Props> = ({ background, title, link, creatorId }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        ref.current.style.setProperty('--action-box-bg', background);
    }, [background, ref]);

    const route = useAppRoute();

    const getPath = useFeaturePath(FEATURE_ROUTER_PATH);

    const handleClick = useCallback(() => {
        route(getPath(`/${creatorId}/${DashboardFeature.name}${link}`));
    }, [getPath, link, route, creatorId]);

    return (
        <div onClick={handleClick} className={css.buttonBox} ref={ref}>
            <p className={css.subTitle}>{title.split(' ')[1].toUpperCase()}</p>
        </div>
    );
};
